import { hotelCodeBatch } from './onboarding';

export const codeCsvMaxBytes = 65536;
export function parseCodeCsv(text: string, direct: boolean) {
  if (new TextEncoder().encode(text).length > codeCsvMaxBytes) throw new Error('size');
  const lines = text.replace(/^\uFEFF/, '').split(/\r\n|\n|\r/);
  const cell = (line: string) => {
    const value = line.trim();
    if (value.startsWith('"')) {
      if (!/^"(?:[^"]|"")*"$/.test(value)) throw new Error('csv');
      return value.slice(1, -1).replace(/""/g, '"').trim();
    }
    if (/[",;]/.test(value)) throw new Error('columns');
    return value;
  };
  if (cell(lines.shift() ?? '') !== 'hotel_code') throw new Error('header');
  const seen = new Set<string>();
  const rows = lines.flatMap((line, index) => {
    if (!line.trim()) return [];
    const code = cell(line);
    // A CSV cell must remain one code when placed in the existing text input.
    const valid = !/[,;\r\n]/.test(code) && hotelCodeBatch(code, direct).valid;
    const status = !valid ? 'invalid' : seen.has(code) ? 'duplicate' : 'valid';
    if (valid) seen.add(code);
    return [{ line: index + 2, code, status }];
  });
  if (!rows.length || rows.length > 200) throw new Error('rows');
  return {
    rows,
    valid: rows.every((row) => row.status !== 'invalid') && seen.size <= 20,
    codes: rows.map((row) => row.code).join('\n'),
    unique: seen.size,
  };
}
